<template>
    <div>
        <div class="timeline__hoverable">
            <header class="timeline__header" @click="goToPeriod">
                <h3 class="timeline__title">{{ period.title }}</h3>
                <span class="timeline__meta"><span class="timeline__date">{{ periodDates }}</span></span>
            </header>
        </div>

        <ul class="timeline__content timeline__content--list">
            <li v-for="assignment in assignments"
                class="timeline__subitem"
                :class="{ 'is-active': isActiveAssignment(assignment), 'is-disabled': isDisabledAssignment(assignment) }"
                @click="goToAssignment($event, assignment)"
                ><span>{{ assignment.title }}</span></li>
        </ul>

    </div>
</template>


<script>


export default {
    name: 'SidebarPeriod',
    props: {
        groupPeriod: {},
        start: {},
        end: {},
        isDemo: {
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            loading: false,
        }
    },
    computed: {
        assignments: function() {
            return this.groupPeriod.groupAssignments
                .map( id => this.$store.state.groups.assignments[id] )
                .filter( ga => !ga.optional )
                .map( ga => this.$store.state.assignments.storage[ga.assignment[0]] )
        },
        period: function() {
            return this.$store.state.periods.storage[ this.groupPeriod.period[0] ]
        },
        periodDates: function() {
            // '1 november - 14 november'
            return this.start.format('D MMMM') + ' - ' + this.end.format('D MMMM')
        },
    },
    methods: {
        goToPeriod: function(e) {
            e.preventDefault()
            this.$router.push({ name: 'group.period', params: { periodId: this.groupPeriod.id } })
        },
        goToAssignment: function(e, assignment) {
            e.preventDefault()
            // prevents goToPeriod() from running
            e.stopPropagation()

            if ( this.isDisabledAssignment(assignment) ) {
                return this.goToPeriod(e)
            }

            this.$router.push({ name: 'group.assignment', params: { assignmentId: assignment.id, periodId: this.groupPeriod.id }})
        },
        isActiveAssignment: function(assignment) {
            return this.$route.params.assignmentId == assignment.id
        },
        isDisabledAssignment: function(assignment) {
            return this.isDemo && !assignment.demo
        }
    },
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Period.vue?7d0d3a5a